"use client";

import { useEffect, useState } from "react";

export default function Testimonials() {
    const testimonials = [
        {
            name: "Ahmed Khan",
            country: "Pakistan",
            review:
                "Amazing stay! The hotel was spotless and the service was exceptional. Will definitely book again.",
            avatar: "https://i.pravatar.cc/100?img=12",
        },
        {
            name: "Sarah Johnson",
            country: "United Kingdom",
            review:
                "Found the best deal on Dubai Hotel Rates. Easy booking process and great customer support.",
            avatar: "https://i.pravatar.cc/100?img=47",
        },
        {
            name: "David Lee",
            country: "Australia",
            review:
                "Highly recommend! The location was perfect and the view was breathtaking.",
            avatar: "https://i.pravatar.cc/100?img=11",
        },
        {
            name: "Maria Wilson",
            country: "United States",
            review:
                "Everything was smooth from booking to check-in. Excellent hotel options and great prices.",
            avatar: "https://i.pravatar.cc/100?img=32",
        },
        {
            name: "Omar Hassan",
            country: "United Arab Emirates",
            review:
                "Very easy to compare hotels and find the right option. The whole experience was excellent.",
            avatar: "https://i.pravatar.cc/100?img=53",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    /* ============================================================
       AUTO SLIDER
    ============================================================ */

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prev) => {
                return (prev + 1) % testimonials.length;
            });
        }, 3000);

        return () => clearInterval(interval);
    }, [testimonials.length]);

    /* ============================================================
       NAVIGATION
    ============================================================ */

    const nextSlide = () => {
        setActiveIndex(
            (prev) => (prev + 1) % testimonials.length
        );
    };

    const prevSlide = () => {
        setActiveIndex(
            (prev) =>
                (prev - 1 + testimonials.length) %
                testimonials.length
        );
    };

    /* ============================================================
       ACTIVE TESTIMONIALS
    ============================================================ */

    const activeTestimonial =
        testimonials[activeIndex];

    const previousTestimonial =
        testimonials[
        (activeIndex - 1 + testimonials.length) %
        testimonials.length
        ];

    const nextTestimonial =
        testimonials[
        (activeIndex + 1) % testimonials.length
        ];

    /* ============================================================
       STAR COMPONENT
    ============================================================ */

    const Stars = ({ size = "h-4 w-4" }) => (
        <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
                <svg
                    key={star}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className={`${size} text-[#D7A74A]`}
                >
                    <path
                        fillRule="evenodd"
                        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.027l-4.627 3.153c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.006Z"
                        clipRule="evenodd"
                    />
                </svg>
            ))}
        </div>
    );

    return (
        <section
            className="
                relative
                overflow-hidden
                bg-[#F3F8FF]
                py-16
                sm:py-20
                lg:py-24
            "

        >

            {/* Top Red Glow */}
            <div
                className="
        pointer-events-none
        absolute
        inset-x-0
        top-0
        h-[180px]
        bg-gradient-to-b
        from-[#8B0000]/50
        to-transparent
    "
            />

            {/* Bottom Red Glow */}
            <div
                className="
        pointer-events-none
        absolute
        inset-x-0
        bottom-0
        h-[180px]
        bg-gradient-to-t
        from-[#8B0000]/40
        via-[#8B0000]/15
        to-transparent
        z-0
    "
            />
            {/* =====================================================
                BACKGROUND DECORATION
            ===================================================== */}

            <div
                className="
                    pointer-events-none
                    absolute
                    -left-40
                    -top-40
                    h-[420px]
                    w-[420px]
                    rounded-full
                    border
                    border-[#D7A74A]/15
                "
            />

            <div
                className="
                    pointer-events-none
                    absolute
                    -left-24
                    -top-24
                    h-[300px]
                    w-[300px]
                    rounded-full
                    border
                    border-[#D7A74A]/10
                "
            />

            <div
                className="
                    pointer-events-none
                    absolute
                    -bottom-48
                    -right-40
                    h-[500px]
                    w-[500px]
                    rounded-full
                    bg-[#0B5552]/5
                    blur-3xl
                "
            />

            <div
                className="
                    pointer-events-none
                    absolute
                    right-[15%]
                    top-[20%]
                    h-40
                    w-40
                    rounded-full
                    bg-[#D7A74A]/10
                    blur-3xl
                "
            />

            {/* =====================================================
                CONTAINER
            ===================================================== */}

            <div
                className="
                    relative
                    z-10
                    mx-auto
                    max-w-[1380px]
                    px-5
                    sm:px-8
                    lg:px-12
                    xl:px-16
                "
            >
                {/* =================================================
                    HEADER
                ================================================= */}

                <div
                    className="
                        mx-auto
                        mb-10
                        max-w-[760px]
                        text-center
                        lg:mb-14
                    "
                >
                    {/* Eyebrow */}

                    <div
                        className="
                            mb-5
                            flex
                            items-center
                            justify-center
                            gap-3
                        "
                    >
                        <span
                            className="
                                h-px
                                w-8
                                bg-[black]
                            "
                        />

                        <span
                            className="
                                text-[10px]
                                font-semibold
                                uppercase
                                tracking-[0.25em]
                                text-[black]
                                sm:text-[11px]
                            "
                        >
                            Guest Experiences
                        </span>

                        <span
                            className="
                                h-px
                                w-8
                                bg-[black]
                            "
                        />
                    </div>

                    {/* Heading */}

                    <h2
                        className="
                            font-serif
                            text-[32px]
                            font-medium
                            leading-[1.08]
                            tracking-[-0.025em]
                            text-[#0B5552]
                            sm:text-[40px]
                            lg:text-[48px]
                            xl:text-[54px]
                        "
                    >
                        Loved by travelers,

                        <span
                            className="
                                block
                                italic
                                text-[#D7A74A]
                            "
                        >
                            remembered for the experience.
                        </span>
                    </h2>

                    {/* Description */}

                    <p
                        className="
                            mx-auto
                            mt-5
                            max-w-[650px]
                            text-[12px]
                            leading-[1.8]
                            text-[#5F6966]
                            sm:text-sm
                            lg:text-[15px]
                        "
                    >
                        Discover what guests from around the world
                        have to say about finding their Dubai stay
                        through Dubai Hotel Rates.
                    </p>
                </div>

                {/* =================================================
                    RATING SUMMARY
                ================================================= */}

                <div
                    className="
                        mb-8
                        flex
                        flex-wrap
                        items-center
                        justify-center
                        gap-x-8
                        gap-y-4
                        sm:mb-10
                    "
                >
                    {/* Rating */}

                    <div className="flex items-center gap-3">
                        <span
                            className="
                                font-serif
                                text-3xl
                                font-medium
                                text-[#0B5552]
                            "
                        >
                            5.0
                        </span>

                        <div>
                            <Stars />

                            <p
                                className="
                                    mt-1
                                    text-[9px]
                                    uppercase
                                    tracking-[0.15em]
                                    text-[#7A8581]
                                "
                            >
                                Guest satisfaction
                            </p>
                        </div>
                    </div>

                    {/* Divider */}

                    <span
                        className="
                            hidden
                            h-8
                            w-px
                            bg-[#D9E1DE]
                            sm:block
                        "
                    />

                    {/* Trust */}

                    <div
                        className="
                            flex
                            items-center
                            gap-2
                            text-[10px]
                            uppercase
                            tracking-[0.14em]
                            text-[#68736F]
                        "
                    >
                        <span
                            className="
                                flex
                                h-7
                                w-7
                                items-center
                                justify-center
                                rounded-full
                                bg-[#D7A74A]/15
                                font-bold
                                text-[#D7A74A]
                            "
                        >
                            ✓
                        </span>

                        Trusted guest experiences
                    </div>
                </div>

                {/* =================================================
                    TESTIMONIAL AREA
                ================================================= */}

                <div className="relative">

                    {/* =================================================
                        DESKTOP PREVIOUS CARD
                    ================================================= */}

                    <div
                        className="
                            absolute
                            left-0
                            top-1/2
                            hidden
                            w-[27%]
                            -translate-y-1/2
                            lg:block
                        "
                    >
                        <div
                            className="
                                relative
                                overflow-hidden
                                rounded-[24px]
                                border
                                border-[#E3E8E6]
                                bg-white
                                p-6
                                opacity-70
                                shadow-[0_15px_45px_rgba(11,85,82,0.06)]
                            "
                        >
                            {/* Quote */}

                            <div
                                className="
                                    absolute
                                    right-5
                                    top-5
                                    font-serif
                                    text-4xl
                                    leading-none
                                    text-[#D7A74A]/30
                                "
                            >
                                “
                            </div>

                            {/* Avatar */}

                            <div
                                className="
                                    mb-5
                                    h-12
                                    w-12
                                    overflow-hidden
                                    rounded-full
                                    border
                                    border-[#E8ECEA]
                                "
                            >
                                <img
                                    src={previousTestimonial.avatar}
                                    alt={previousTestimonial.name}
                                    className="
                                        h-full
                                        w-full
                                        object-cover
                                    "
                                />
                            </div>

                            {/* Review */}

                            <p
                                className="
                                    line-clamp-3
                                    text-[12px]
                                    leading-6
                                    text-[#69736F]
                                "
                            >
                                {previousTestimonial.review}
                            </p>

                            {/* Name */}

                            <p
                                className="
                                    mt-5
                                    font-serif
                                    text-sm
                                    text-[#0B5552]
                                "
                            >
                                {previousTestimonial.name}
                            </p>

                            <p
                                className="
                                    mt-1
                                    text-[9px]
                                    uppercase
                                    tracking-[0.12em]
                                    text-[#929B98]
                                "
                            >
                                {previousTestimonial.country}
                            </p>
                        </div>
                    </div>

                    {/* =================================================
                        FEATURED CARD
                    ================================================= */}

                    <div
                        className="
                            relative
                            mx-auto
                            w-full
                            max-w-[760px]
                            lg:w-[48%]
                        "
                    >
                        <div
                            className="
                                relative
                                overflow-hidden
                                rounded-[28px]
                                border
                                border-[#E2E8E5]
                                bg-white
                                shadow-[0_25px_70px_rgba(11,85,82,0.12)]
                                transition-all
                                duration-500
                            "
                        >
                            {/* Gold top line */}

                            <div
                                className="
                                    absolute
                                    left-0
                                    right-0
                                    top-0
                                    h-1
                                    bg-[#D7A74A]
                                "
                            />

                            <div
                                className="
                                    p-7
                                    sm:p-9
                                    lg:p-10
                                "
                            >
                                {/* Quote + Stars */}

                                <div
                                    className="
                                        flex
                                        items-start
                                        justify-between
                                    "
                                >
                                    <div
                                        className="
                                            font-serif
                                            text-[72px]
                                            leading-[0.7]
                                            text-[#D7A74A]/30
                                        "
                                    >
                                        “
                                    </div>

                                    <div
                                        className="
                                            rounded-full
                                            border
                                            border-[#E9EEEC]
                                            bg-[#F3F8FF]
                                            px-3
                                            py-1.5
                                        "
                                    >
                                        <Stars size="h-3.5 w-3.5" />
                                    </div>
                                </div>

                                {/* Review */}

                                <p
                                    className="
                                        mt-7
                                        font-serif
                                        text-[20px]
                                        font-medium
                                        leading-[1.65]
                                        tracking-[-0.01em]
                                        text-[#0B5552]
                                        sm:text-[24px]
                                        lg:text-[26px]
                                    "
                                >
                                    {activeTestimonial.review}
                                </p>

                                {/* Divider */}

                                <div
                                    className="
                                        my-7
                                        h-px
                                        bg-[#E8EDEB]
                                    "
                                />

                                {/* Guest */}

                                <div
                                    className="
                                        flex
                                        items-center
                                        justify-between
                                        gap-4
                                    "
                                >
                                    <div
                                        className="
                                            flex
                                            items-center
                                            gap-4
                                        "
                                    >
                                        {/* Avatar */}

                                        <div
                                            className="
                                                h-14
                                                w-14
                                                shrink-0
                                                overflow-hidden
                                                rounded-full
                                                ring-4
                                                ring-[#F3F8FF]
                                            "
                                        >
                                            <img
                                                src={
                                                    activeTestimonial.avatar
                                                }
                                                alt={
                                                    activeTestimonial.name
                                                }
                                                className="
                                                    h-full
                                                    w-full
                                                    object-cover
                                                "
                                            />
                                        </div>

                                        {/* Guest info */}

                                        <div>
                                            <h3
                                                className="
                                                    font-serif
                                                    text-lg
                                                    font-medium
                                                    text-[#0B5552]
                                                "
                                            >
                                                {activeTestimonial.name}
                                            </h3>

                                            <div
                                                className="
                                                    mt-1
                                                    flex
                                                    flex-wrap
                                                    items-center
                                                    gap-2
                                                "
                                            >
                                                <span
                                                    className="
                                                        text-[11px]
                                                        text-[#747A77]
                                                    "
                                                >
                                                    {
                                                        activeTestimonial.country
                                                    }
                                                </span>

                                                <span
                                                    className="
                                                        h-1
                                                        w-1
                                                        rounded-full
                                                        bg-[#D7A74A]
                                                    "
                                                />

                                                <span
                                                    className="
                                                        text-[9px]
                                                        font-bold
                                                        uppercase
                                                        tracking-[0.12em]
                                                        text-[#8B0000]
                                                    "
                                                >
                                                    Verified Guest
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Quote circle */}

                                    <div
                                        className="
                                            hidden
                                            h-11
                                            w-11
                                            items-center
                                            justify-center
                                            rounded-full
                                            bg-[#0B5552]
                                            text-lg
                                            text-[#D7A74A]
                                            sm:flex
                                        "
                                    >
                                        “
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* =================================================
                        DESKTOP NEXT CARD
                    ================================================= */}

                    <div
                        className="
                            absolute
                            right-0
                            top-1/2
                            hidden
                            w-[27%]
                            -translate-y-1/2
                            lg:block
                        "
                    >
                        <div
                            className="
                                relative
                                overflow-hidden
                                rounded-[24px]
                                border
                                border-[#E3E8E6]
                                bg-white
                                p-6
                                opacity-70
                                shadow-[0_15px_45px_rgba(11,85,82,0.06)]
                            "
                        >
                            {/* Quote */}

                            <div
                                className="
                                    absolute
                                    right-5
                                    top-5
                                    font-serif
                                    text-4xl
                                    leading-none
                                    text-[#D7A74A]/30
                                "
                            >
                                “
                            </div>

                            {/* Avatar */}

                            <div
                                className="
                                    mb-5
                                    h-12
                                    w-12
                                    overflow-hidden
                                    rounded-full
                                    border
                                    border-[#E8ECEA]
                                "
                            >
                                <img
                                    src={nextTestimonial.avatar}
                                    alt={nextTestimonial.name}
                                    className="
                                        h-full
                                        w-full
                                        object-cover
                                    "
                                />
                            </div>

                            {/* Review */}

                            <p
                                className="
                                    line-clamp-3
                                    text-[12px]
                                    leading-6
                                    text-[#69736F]
                                "
                            >
                                {nextTestimonial.review}
                            </p>

                            {/* Name */}

                            <p
                                className="
                                    mt-5
                                    font-serif
                                    text-sm
                                    text-[#0B5552]
                                "
                            >
                                {nextTestimonial.name}
                            </p>

                            <p
                                className="
                                    mt-1
                                    text-[9px]
                                    uppercase
                                    tracking-[0.12em]
                                    text-[#929B98]
                                "
                            >
                                {nextTestimonial.country}
                            </p>
                        </div>
                    </div>

                    {/* =================================================
                        MOBILE / TABLET CONTROLS
                    ================================================= */}

                    <div
                        className="
                            mt-6
                            flex
                            items-center
                            justify-center
                            gap-3
                            lg:hidden
                        "
                    >
                        {/* Previous */}

                        <button
                            type="button"
                            onClick={prevSlide}
                            aria-label="Previous testimonial"
                            className="
                                flex
                                h-11
                                w-11
                                items-center
                                justify-center
                                rounded-full
                                border
                                border-[#DDE5E2]
                                bg-white
                                text-[#0B5552]
                                shadow-[0_5px_20px_rgba(11,85,82,0.08)]
                                transition-all
                                duration-300
                                hover:border-[#D7A74A]
                                hover:bg-[#D7A74A]
                            "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.7}
                                stroke="currentColor"
                                className="h-4 w-4"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M15.75 19.5 8.25 12l7.5-7.5"
                                />
                            </svg>
                        </button>

                        {/* Dots */}

                        <div
                            className="
                                flex
                                items-center
                                gap-1.5
                                rounded-full
                                border
                                border-[#E1E8E5]
                                bg-white
                                px-3
                                py-2
                                shadow-[0_5px_20px_rgba(11,85,82,0.05)]
                            "
                        >
                            {testimonials.map(
                                (testimonial, index) => (
                                    <button
                                        key={testimonial.name}
                                        type="button"
                                        aria-label={`Show testimonial ${index + 1
                                            }`}
                                        onClick={() =>
                                            setActiveIndex(index)
                                        }
                                        className={`
                                            h-1.5
                                            rounded-full
                                            transition-all
                                            duration-300
                                            ${activeIndex === index
                                                ? "w-7 bg-[#D7A74A]"
                                                : "w-1.5 bg-[#C8D3CF] hover:bg-[#9EACA7]"
                                            }
                                        `}
                                    />
                                )
                            )}
                        </div>

                        {/* Next */}

                        <button
                            type="button"
                            onClick={nextSlide}
                            aria-label="Next testimonial"
                            className="
                                flex
                                h-11
                                w-11
                                items-center
                                justify-center
                                rounded-full
                                border
                                border-[#DDE5E2]
                                bg-white
                                text-[#0B5552]
                                shadow-[0_5px_20px_rgba(11,85,82,0.08)]
                                transition-all
                                duration-300
                                hover:border-[#D7A74A]
                                hover:bg-[#D7A74A]
                            "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.7}
                                stroke="currentColor"
                                className="h-4 w-4"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="m8.25 4.5 7.5 7.5-7.5 7.5"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* =================================================
                        DESKTOP CONTROLS
                    ================================================= */}

                    <div
                        className="
                            mt-8
                            hidden
                            items-center
                            justify-center
                            gap-4
                            lg:flex
                        "
                    >
                        {/* Previous */}

                        <button
                            type="button"
                            onClick={prevSlide}
                            aria-label="Previous testimonial"
                            className="
                                flex
                                h-10
                                w-10
                                items-center
                                justify-center
                                rounded-full
                                border
                                border-[#DDE5E2]
                                bg-white
                                text-[#0B5552]
                                shadow-[0_5px_20px_rgba(11,85,82,0.06)]
                                transition-all
                                duration-300
                                hover:border-[#D7A74A]
                                hover:bg-[#D7A74A]
                            "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.7}
                                stroke="currentColor"
                                className="h-4 w-4"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M15.75 19.5 8.25 12l7.5-7.5"
                                />
                            </svg>
                        </button>

                        {/* Dots */}

                        <div className="flex items-center gap-2">
                            {testimonials.map(
                                (testimonial, index) => (
                                    <button
                                        key={testimonial.name}
                                        type="button"
                                        aria-label={`Show testimonial ${index + 1
                                            }`}
                                        onClick={() =>
                                            setActiveIndex(index)
                                        }
                                        className={`
                                            h-1.5
                                            rounded-full
                                            transition-all
                                            duration-300
                                            ${activeIndex === index
                                                ? "w-8 bg-[#D7A74A]"
                                                : "w-1.5 bg-[#C8D3CF] hover:bg-[#9EACA7]"
                                            }
                                        `}
                                    />
                                )
                            )}
                        </div>

                        {/* Next */}

                        <button
                            type="button"
                            onClick={nextSlide}
                            aria-label="Next testimonial"
                            className="
                                flex
                                h-10
                                w-10
                                items-center
                                justify-center
                                rounded-full
                                border
                                border-[#DDE5E2]
                                bg-white
                                text-[#0B5552]
                                shadow-[0_5px_20px_rgba(11,85,82,0.06)]
                                transition-all
                                duration-300
                                hover:border-[#D7A74A]
                                hover:bg-[#D7A74A]
                            "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.7}
                                stroke="currentColor"
                                className="h-4 w-4"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="m8.25 4.5 7.5 7.5-7.5 7.5"
                                />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* =================================================
                    BOTTOM TRUST MESSAGE
                ================================================= */}

                <div
                    className="
                        mt-12
                        flex
                        flex-col
                        items-center
                        justify-center
                        gap-2
                        text-center
                        sm:mt-14
                        sm:flex-row
                        sm:gap-4
                    "
                >
                    <span
                        className="
                            text-[9px]
                            font-semibold
                            uppercase
                            tracking-[0.18em]
                            text-[#6B7471]
                        "
                    >
                        Dubai Hotel Rates
                    </span>

                    <span
                        className="
                            hidden
                            h-1
                            w-1
                            rounded-full
                            bg-[#D7A74A]
                            sm:block
                        "
                    />

                    <span
                        className="
                            text-[9px]
                            uppercase
                            tracking-[0.16em]
                            text-[#7B8581]
                        "
                    >
                        Luxury stays • Better rates • Easy booking
                    </span>
                </div>
            </div>
        </section>
    );
}